import type { InventoryUnit } from '../types/inventory';

export function areUnitsCompatible(left: InventoryUnit, right: InventoryUnit) {
  if (left.id === right.id) return true;
  if (left.type !== right.type || left.type === 'OTHER') return false;
  return Number(left.conversionToBaseFactor) > 0 && Number(right.conversionToBaseFactor) > 0;
}

export function compatibleUnitOptions(units: InventoryUnit[], baseUnit: InventoryUnit | undefined, currentUnitId?: string): Array<[string, string]> {
  return units
    .filter((unit) => unit.isActive || unit.id === currentUnitId)
    .filter((unit) => !baseUnit || areUnitsCompatible(unit, baseUnit))
    .map((unit) => [unit.id, `${unit.name} (${unit.symbol})`]);
}
